export default __webpack_public_path__ + "static/media/cart-icon.8fc611d2.jpg";